import { render, staticRenderFns } from "./SeparationOfFundsTabV2.vue?vue&type=template&id=c657db40&scoped=true"
import script from "./SeparationOfFundsTabV2.vue?vue&type=script&lang=js"
export * from "./SeparationOfFundsTabV2.vue?vue&type=script&lang=js"
import style0 from "./SeparationOfFundsTabV2.vue?vue&type=style&index=0&id=c657db40&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c657db40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c657db40')) {
      api.createRecord('c657db40', component.options)
    } else {
      api.reload('c657db40', component.options)
    }
    module.hot.accept("./SeparationOfFundsTabV2.vue?vue&type=template&id=c657db40&scoped=true", function () {
      api.rerender('c657db40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/proposalHistory/tabs/SeparationOfFundsTabV2.vue"
export default component.exports